import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"
// import { AttractionType } from "@/common/types"

function useListAttractions({
  filters,
}: {
  filters: { filterValue: string[] }
}) {
  return useQuery({
    queryKey: queryKeys.attractions.list({}).queryKey,
    queryFn: () =>
      client
        .get(`/attractions/`, { params: { ...filters } })
        .then((response) => response.data),
  })
}
export default useListAttractions
